import { useMemo } from "react";

import "./button.scss";

type DeciderButtonTwoOptionsProps = {
  decider: number;
  handleChange: (value: number) => void;
  defaultButton: string;
  secondButton: string;
};

export const DeciderButtonsTwoOptions: React.FC<DeciderButtonTwoOptionsProps> = ({
  decider,
  handleChange,
  defaultButton,
  secondButton,
}) => {
  return useMemo(() => {
    return (
      <div>
        <button
          className={`${decider === 1 ? "selected" : "not-selected"}`}
          onClick={() => handleChange(1)}
        >
          {defaultButton}
        </button>
        <button
          className={`${decider === 2 ? "selected" : "not-selected"}`}
          onClick={() => handleChange(2)}
        >
          {secondButton}
        </button>
      </div>
    );
  }, [decider, defaultButton, secondButton, handleChange]);
};
